import React from 'react';
import PropTypes from 'prop-types';
import { PaymentRequestActions } from '../utils/ols-core';

export class PaymentRequestButton extends React.Component {
  constructor() {
    super(...arguments);
    this.state = {
      btnWidth: null,
      widthSynced: false
    };
    this.btnClass = 'payment-request-button-container';
  }

  componentDidMount() {
    const { layoutMode, initPage, styles, getOrderData, phoneRequired } = this.props;
    const btnSelector = '.' + this.btnClass + '.' + layoutMode;
    this.prButton = PaymentRequestActions.startSession({
      initPage,
      btnSelector,
      styles,
      getOrderData,
      phoneRequired
    });

    this._isMounted = true;
    window.addEventListener('resize', this.handleResize);
  }

  componentDidUpdate() {
    const { widthSynced } = this.state;
    const { matchingButtonId } = this.props;

    if (matchingButtonId && !widthSynced) {
      const matchingButton = Array.prototype.slice
        .call(document.querySelectorAll(matchingButtonId))
        .find(el => el.offsetHeight || el.clientHeight);

      if (matchingButton) {
        const matchingHeight = matchingButton.offsetHeight || matchingButton.clientHeight;
        this.prButton.update({
          style: { paymentRequestButton: { height: matchingHeight + 'px' } }
        });
        this.setState({
          btnWidth: matchingButton.offsetWidth + 'px',
          widthSynced: true
        });
      }
    }
  }

  componentWillUnmount() {
    if (this.prButton) {
      this.prButton.destroy();
      this.prButton = null;
    }

    this._isMounted = false;
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    if (!this._resizeTimer) {
      this._resizeTimer = setTimeout(
        function () {
          this._resizeTimer = null;
          if (this._isMounted) {
            this.setState({ widthSynced: false });
          }
        }.bind(this),
        66
      );
    }
  };

  render() {
    const { layoutMode, disabled, dataAid } = this.props;
    const { btnWidth } = this.state;
    var styles = disabled
      ? {
        pointerEvents: 'none',
        cursor: 'not-allowed',
        opacity: 0.4
      }
      : {};

    if (btnWidth) {
      styles.width = btnWidth;
    }

    return <div className={ `${this.btnClass} ${layoutMode}` } style={ styles } data-aid={ dataAid } />;
  }
}

PaymentRequestButton.propTypes = {
  phoneRequired: PropTypes.bool,
  getOrderData: PropTypes.func,
  styles: PropTypes.object,
  matchingButtonId: PropTypes.string,
  disabled: PropTypes.bool,
  dataAid: PropTypes.string,
  layoutMode: PropTypes.string.isRequired,
  initPage: PropTypes.string.isRequired
};
